import { dynamicHead } from '@/mixins/dynamic-head';

export default {
  name: 'ServerMaintenance',
  mixins: [dynamicHead],
  created() {
    this.metaParams.prerender = {
      content: '503'
    };
    this.setMeta();
  }
};
